import * as i0 from '@angular/core';
import { Directive, Input, EventEmitter, forwardRef, Component, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/forms';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlContainer, NgForm, FormsModule } from '@angular/forms';
import * as i2 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i3 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i5 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i6 from '@angular/material/core';
import { MatRippleModule } from '@angular/material/core';
import * as i8 from '@ngx-translate/core';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

class LocaleGroupValidator {
    validate(control) {
        let invalid = false;
        if (control.value && this.required) {
            for (let key in control.value) {
                if (control.value.hasOwnProperty(key)) {
                    if (control.value[key] === '' || control.value[key] == undefined) {
                        invalid = true;
                    }
                }
            }
        }
        if (invalid) {
            return { localeGroupValid: invalid };
        }
        else {
            return null;
        }
    }
}
/** @nocollapse */ LocaleGroupValidator.ɵfac = function LocaleGroupValidator_Factory(t) { return new (t || LocaleGroupValidator)(); };
/** @nocollapse */ LocaleGroupValidator.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: LocaleGroupValidator, selectors: [["", "localeGroupValid", ""]], inputs: { required: "required" }, features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: LocaleGroupValidator, multi: true }])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocaleGroupValidator, [{
        type: Directive,
        args: [{
                selector: '[localeGroupValid]',
                providers: [{ provide: NG_VALIDATORS, useExisting: LocaleGroupValidator, multi: true }],
            }]
    }], null, { required: [{
            type: Input,
            args: ['required']
        }] }); })();

const _c0 = function (a0) { return { "invalid": a0 }; };
function MultiLocaleComponent_div_2_div_1_mat_form_field_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 10)(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 11);
    i0.ɵɵlistener("ngModelChange", function MultiLocaleComponent_div_2_div_1_mat_form_field_1_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r10); const locale_r6 = i0.ɵɵnextContext().$implicit; const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView((ctx_r9.returnModel[locale_r6[ctx_r9.localeIdentifier]] = $event)); })("blur", function MultiLocaleComponent_div_2_div_1_mat_form_field_1_Template_input_blur_3_listener() { i0.ɵɵrestoreView(_r10); const i_r7 = i0.ɵɵnextContext().index; const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.onInputChange(i_r7)); })("keyup.escape", function MultiLocaleComponent_div_2_div_1_mat_form_field_1_Template_input_keyup_escape_3_listener() { i0.ɵɵrestoreView(_r10); const ctx_r14 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r14.closePopup()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const locale_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r8 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0, _r0.invalid && (_r0.dirty || _r0.touched) && (_r0.errors && _r0.errors.localeGroupValid)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r8.label, " - ", locale_r6[ctx_r8.localeLabel], "");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r8.groupId, "_", locale_r6[ctx_r8.localeIdentifier].toLowerCase(), "")("name", "", ctx_r8.groupId, "_", locale_r6[ctx_r8.localeIdentifier].toLowerCase(), "");
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r8.placeholder);
    i0.ɵɵproperty("ngModel", ctx_r8.returnModel[locale_r6[ctx_r8.localeIdentifier]])("required", ctx_r8.isRequired)("maxlength", ctx_r8.length);
    i0.ɵɵattribute("data-url-persist", ctx_r8.deeplinkPersist);
} }
function MultiLocaleComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MultiLocaleComponent_div_2_div_1_mat_form_field_1_Template, 4, 14, "mat-form-field", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const locale_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r7 === 0 && locale_r6[ctx_r3.localeIdentifier]);
} }
function MultiLocaleComponent_div_2_mat_error_2_mat_error_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error")(1, "span", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "multi-locale-input.MultiLocaleInput.app.locale_error"));
} }
function MultiLocaleComponent_div_2_mat_error_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error", 12);
    i0.ɵɵtemplate(1, MultiLocaleComponent_div_2_mat_error_2_mat_error_1_Template, 4, 3, "mat-error", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r0.errors && _r0.errors.localeGroupValid);
} }
const _c1 = function (a0, a1) { return { "active": a0, "invalid": a1 }; };
function MultiLocaleComponent_div_2_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 15);
    i0.ɵɵlistener("click", function MultiLocaleComponent_div_2_mat_icon_3_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.toggleExpand()); })("keyup.enter", function MultiLocaleComponent_div_2_mat_icon_3_Template_mat_icon_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r19.toggleExpand()); })("keyup.escape", function MultiLocaleComponent_div_2_mat_icon_3_Template_mat_icon_keyup_escape_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.closePopup()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2, "language");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 2, "multi-locale-input.MultiLocaleInput.app.globe_tooltip"));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c1, ctx_r5.expanded, _r0.invalid && (_r0.dirty || _r0.touched) && (_r0.errors && _r0.errors.localeGroupValid)));
} }
function MultiLocaleComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, MultiLocaleComponent_div_2_div_1_Template, 2, 1, "div", 4);
    i0.ɵɵtemplate(2, MultiLocaleComponent_div_2_mat_error_2_Template, 2, 1, "mat-error", 7);
    i0.ɵɵtemplate(3, MultiLocaleComponent_div_2_mat_icon_3_Template, 3, 7, "mat-icon", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.supportedLocales);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r0.invalid && (_r0.dirty || _r0.touched));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.supportedLocales && ctx_r1.supportedLocales.length > 1);
} }
function MultiLocaleComponent_div_4_div_1_mat_error_6_mat_error_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "multi-locale-input.MultiLocaleInput.app.required"));
} }
function MultiLocaleComponent_div_4_div_1_mat_error_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error", 20);
    i0.ɵɵtemplate(1, MultiLocaleComponent_div_4_div_1_mat_error_6_mat_error_1_Template, 4, 3, "mat-error", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r24 = i0.ɵɵreference(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r24.errors && _r24.errors["required"]);
} }
function MultiLocaleComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "mat-form-field", 16)(2, "mat-label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 17, 18);
    i0.ɵɵlistener("blur", function MultiLocaleComponent_div_4_div_1_Template_input_blur_4_listener() { i0.ɵɵrestoreView(_r29); const i_r22 = i0.ɵɵnextContext().index; const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.onInputChange(i_r22)); })("ngModelChange", function MultiLocaleComponent_div_4_div_1_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r29); const locale_r21 = i0.ɵɵnextContext().$implicit; const ctx_r30 = i0.ɵɵnextContext(); return i0.ɵɵresetView((ctx_r30.returnModel[locale_r21[ctx_r30.localeIdentifier]] = $event)); })("keyup.escape", function MultiLocaleComponent_div_4_div_1_Template_input_keyup_escape_4_listener() { i0.ɵɵrestoreView(_r29); const ctx_r32 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r32.closePopup()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, MultiLocaleComponent_div_4_div_1_mat_error_6_Template, 2, 1, "mat-error", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r24 = i0.ɵɵreference(5);
    const locale_r21 = i0.ɵɵnextContext().$implicit;
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", ctx_r23.label, " - ", locale_r21[ctx_r23.localeLabel], "");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r23.groupId, "_", locale_r21[ctx_r23.localeIdentifier].toLowerCase(), "")("name", "", ctx_r23.groupId, "_", locale_r21[ctx_r23.localeIdentifier].toLowerCase(), "");
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r23.placeholder);
    i0.ɵɵproperty("ngModel", ctx_r23.returnModel[locale_r21[ctx_r23.localeIdentifier]])("required", ctx_r23.isRequired)("maxlength", ctx_r23.length);
    i0.ɵɵattribute("data-url-persist", ctx_r23.deeplinkPersist);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", _r24.invalid && (_r24.dirty || _r24.touched));
} }
function MultiLocaleComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MultiLocaleComponent_div_4_div_1_Template, 7, 12, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const locale_r21 = ctx.$implicit;
    const i_r22 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r22 > 0 && locale_r21[ctx_r2.localeIdentifier]);
} }
const _c2 = function (a0) { return { "slide-down": a0 }; };
const _c3 = function (a0) { return { "show": a0 }; };
class MultiLocaleComponent {
    constructor() {
        this._returnModel = {};
        this.localeIdentifier = 'localeName';
        this.localeLabel = 'displayLabel';
        this.expanded = false;
        this.placeholder = 'Enter a value';
        this.label = 'Field Name';
        this.isRequired = false;
        this.groupId = '';
        this.length = 80;
        this.persist = null;
        this.onChange = new EventEmitter();
        this.propagateChange = (_) => { };
    }
    set locales(locales) {
        this.supportedLocales = locales;
        this.updateModel();
        this.setDefault();
    }
    set inputLabel(label) {
        this.label = label;
    }
    set localeKey(key) {
        if (key === '') {
            key = 'localeName';
        }
        this.localeIdentifier = key;
    }
    set displayLabelKey(key) {
        if (key === '') {
            key = 'displayLabel';
        }
        this.localeLabel = key;
    }
    set defaultLocale(locale) {
        if (typeof (locale) === 'undefined') {
            locale = {};
        }
        this.startingLocale = locale;
        this.setDefault();
    }
    set placeholderText(placeholder) {
        this.placeholder = placeholder;
    }
    set required(required) {
        this.isRequired = required;
    }
    set maxLength(length) {
        this.length = length;
    }
    set id(id) {
        this.groupId = id;
    }
    get deeplinkPersist() {
        return this.persist;
    }
    set deeplinkPersist(persist) {
        this.persist = persist;
    }
    get returnModel() {
        return this._returnModel;
    }
    set returnModel(val) {
        if (typeof (val) === 'undefined') {
            val = {};
        }
        this._returnModel = val;
        this.propagateChange(this.returnModel);
    }
    writeValue(obj) {
        if (obj) {
            this.returnModel = obj;
        }
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
    }
    validate(control) {
        let invalid = false;
        if (control.value && this.isRequired && this.supportedLocales.length > 0) {
            for (let locale of this.supportedLocales) {
                const keys = Object.keys(control.value);
                if (!keys.includes(locale[this.localeIdentifier]) || control.value[locale[this.localeIdentifier]] === "" || control.value[locale[this.localeIdentifier]] == undefined) {
                    invalid = true;
                }
            }
        }
        if (invalid) {
            return { localeGroupValid: invalid };
        }
        else {
            return null;
        }
    }
    toggleExpand() {
        this.expanded = !this.expanded;
    }
    closePopup() {
        this.expanded = false;
    }
    updateModel() {
        if (this.supportedLocales && this.supportedLocales.length > 0) {
            for (let key in this.returnModel) {
                if (this.returnModel.hasOwnProperty(key) &&
                    this.supportedLocales.find(locale => key === locale[this.localeIdentifier]) == undefined) {
                    delete this.returnModel[key];
                }
            }
        }
    }
    setDefault() {
        if (this.startingLocale && this.supportedLocales && this.supportedLocales.length > 0) {
            const defaultLocaleindex = this.supportedLocales.findIndex(locale => locale[this.localeIdentifier] === this.startingLocale[this.localeIdentifier]);
            if (defaultLocaleindex >= 0) {
                this.supportedLocales.splice(defaultLocaleindex, 1);
                this.supportedLocales.unshift(this.startingLocale);
            }
        }
    }
    onInputChange(inputIndex) {
        this.propagateChange({ ...this.returnModel });
        this.onChange.emit({ ...this.returnModel });
        if (inputIndex >= (this.supportedLocales.length - 1) && this.expanded) {
            this.closePopup();
        }
    }
    ngOnInit() { }
}
/** @nocollapse */ MultiLocaleComponent.ɵfac = function MultiLocaleComponent_Factory(t) { return new (t || MultiLocaleComponent)(); };
/** @nocollapse */ MultiLocaleComponent.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: MultiLocaleComponent, selectors: [["multi-locale-input"]], inputs: { locales: "locales", inputLabel: "inputLabel", localeKey: "localeKey", displayLabelKey: "displayLabelKey", defaultLocale: "defaultLocale", placeholderText: "placeholderText", required: "required", maxLength: "maxLength", id: "id", deeplinkPersist: ["deeplink-persist", "deeplinkPersist"] }, outputs: { onChange: "onChange" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef((() => MultiLocaleComponent)),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef((() => MultiLocaleComponent)),
                multi: true,
            }
        ], [{ provide: ControlContainer, useExisting: NgForm }])], decls: 6, vars: 10, consts: [["localeGroupValid", "", 1, "contain", 3, "ngModelGroup", "required"], ["localeInputs", "ngModelGroup"], ["class", "contain", 4, "ngIf"], [1, "pop-out-container", 3, "ngClass"], [4, "ngFor", "ngForOf"], [1, "multi-locale-overlay", 3, "ngClass", "click"], [1, "contain"], ["class", "group-error-wrapper", 4, "ngIf"], ["class", "language-icon", "matRipple", "", "matRippleCentered", "centered", "tabindex", "0", 3, "ngClass", "title", "click", "keyup.enter", "keyup.escape", 4, "ngIf"], ["appearance", "outline", "floatLabel", "always", 3, "ngClass", 4, "ngIf"], ["appearance", "outline", "floatLabel", "always", 3, "ngClass"], ["matInput", "", 3, "id", "name", "ngModel", "placeholder", "required", "maxlength", "ngModelChange", "blur", "keyup.escape"], [1, "group-error-wrapper"], [4, "ngIf"], [1, "group-error"], ["matRipple", "", "matRippleCentered", "centered", "tabindex", "0", 1, "language-icon", 3, "ngClass", "title", "click", "keyup.enter", "keyup.escape"], ["appearance", "outline", "floatLabel", "always"], ["matInput", "", 3, "id", "name", "ngModel", "placeholder", "required", "maxlength", "blur", "ngModelChange", "keyup.escape"], ["defaultLocaleString", "ngModel"], ["class", "alert alert-danger", 4, "ngIf"], [1, "alert", "alert-danger"]], template: function MultiLocaleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0, 1);
        i0.ɵɵtemplate(2, MultiLocaleComponent_div_2_Template, 4, 3, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, MultiLocaleComponent_div_4_Template, 2, 1, "div", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵlistener("click", function MultiLocaleComponent_Template_div_click_5_listener() { return ctx.closePopup(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵpropertyInterpolate1("ngModelGroup", "localeInputsForm_", ctx.groupId, "");
        i0.ɵɵproperty("required", ctx.isRequired);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.supportedLocales && ctx.supportedLocales.length > 0 && ctx.returnModel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2, ctx.expanded));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.supportedLocales);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c3, ctx.expanded));
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.MatError, i2.MatFormField, i2.MatLabel, i3.MatInput, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.RequiredValidator, i4.MaxLengthValidator, i4.NgModel, i4.NgModelGroup, i5.MatIcon, i6.MatRipple, LocaleGroupValidator, i8.TranslatePipe], styles: ["input[_ngcontent-%COMP%]{border:none;padding-right:25px}input.failure[_ngcontent-%COMP%]{outline:#FF0000}.hide[_ngcontent-%COMP%]{display:none}.contain[_ngcontent-%COMP%]{position:relative}.language-icon[_ngcontent-%COMP%]{position:absolute;top:17px;right:5px;color:#461e7d;opacity:1}.language-icon[_ngcontent-%COMP%]:hover, .language-icon.active[_ngcontent-%COMP%]{cursor:pointer;border-radius:32px;opacity:.5}.language-icon.invalid[_ngcontent-%COMP%]{color:red}.pop-out-container[_ngcontent-%COMP%]{display:none}.slide-down[_ngcontent-%COMP%]{display:block}.mat-form-field[_ngcontent-%COMP%]{width:100%}.mat-form-field.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-outline[_ngcontent-%COMP%]{color:red}.mat-form-field.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-outline-thick[_ngcontent-%COMP%]{color:red;opacity:1}.invalid[_ngcontent-%COMP%]   .mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-outline[_ngcontent-%COMP%]{color:red}.mat-error[_ngcontent-%COMP%]   .group-error[_ngcontent-%COMP%]{font-size:75%;padding-left:10px;font-weight:400;line-height:1.125;font-family:Avenir;letter-spacing:1.5px;display:block}.group-error-wrapper[_ngcontent-%COMP%]{margin-top:-15px}@keyframes slide-down{to{top:60px;opacity:1;display:block}}@media only screen and (min-width: 768px){.pop-out-container[_ngcontent-%COMP%]{background:#ffffff;border:solid 1px #999;border-radius:3px;box-shadow:1px 2px 6px #0006;padding:20px 20px 0;display:none;z-index:10000;position:absolute;width:100%}.pop-out-container[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{padding-bottom:15px}.multi-locale-overlay[_ngcontent-%COMP%]{display:none}.multi-locale-overlay.show[_ngcontent-%COMP%]{position:absolute;z-index:9999;width:100%;height:100%;display:block;top:0;left:0}.slide-down[_ngcontent-%COMP%]{top:0;opacity:0;-webkit-animation:slide-down .25s forwards;-webkit-animation-delay:0s;animation:slide-down .25s forwards;animation-delay:0s;display:block}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiLocaleComponent, [{
        type: Component,
        args: [{ selector: 'multi-locale-input', viewProviders: [{ provide: ControlContainer, useExisting: NgForm }], providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((() => MultiLocaleComponent)),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef((() => MultiLocaleComponent)),
                        multi: true,
                    }
                ], template: "<div class=\"contain\" ngModelGroup=\"localeInputsForm_{{groupId}}\" #localeInputs=\"ngModelGroup\" localeGroupValid [required]=\"isRequired\">\n  <div class=\"contain\" *ngIf=\"supportedLocales && supportedLocales.length > 0 && returnModel\">\n    <div *ngFor=\"let locale of supportedLocales; let i = index\">\n      <mat-form-field appearance=\"outline\" floatLabel=\"always\" *ngIf=\"i === 0 && locale[localeIdentifier]\" [ngClass]=\"{\n                'invalid': localeInputs.invalid &&\n                           (localeInputs.dirty || localeInputs.touched) &&\n                           (localeInputs.errors && localeInputs.errors.localeGroupValid)\n                          }\">\n          <mat-label>{{label}} - {{locale[localeLabel]}}</mat-label>\n        <input\n          matInput\n          id=\"{{groupId}}_{{locale[localeIdentifier].toLowerCase()}}\"\n          name=\"{{groupId}}_{{locale[localeIdentifier].toLowerCase()}}\"\n          [(ngModel)]=\"returnModel[locale[localeIdentifier]]\"\n          placeholder=\"{{ placeholder }}\"\n          (blur)=\"onInputChange(i)\"\n          [required]=\"isRequired\"\n          [maxlength]=\"length\"\n          [attr.data-url-persist]=\"deeplinkPersist\"\n          (keyup.escape)=\"closePopup()\"\n        >\n      </mat-form-field>\n    </div>\n    <mat-error\n      *ngIf=\"localeInputs.invalid && (localeInputs.dirty || localeInputs.touched)\"\n      class=\"group-error-wrapper\"\n    >\n      <mat-error *ngIf=\"localeInputs.errors && localeInputs.errors.localeGroupValid\">\n        <span class=\"group-error\">{{ \"multi-locale-input.MultiLocaleInput.app.locale_error\" | translate }}</span>\n      </mat-error>\n    </mat-error>\n    <mat-icon [ngClass]=\"{\n                'active': expanded,\n                'invalid': localeInputs.invalid &&\n                           (localeInputs.dirty || localeInputs.touched) &&\n                           (localeInputs.errors && localeInputs.errors.localeGroupValid)\n                          }\"\n              class=\"language-icon\"\n              matRipple\n              matRippleCentered='centered'\n              (click)=\"toggleExpand()\"\n              *ngIf=\"supportedLocales && supportedLocales.length > 1\"\n              title=\"{{ 'multi-locale-input.MultiLocaleInput.app.globe_tooltip' | translate}}\"\n              tabindex=\"0\"\n              (keyup.enter)=\"toggleExpand()\"\n              (keyup.escape)=\"closePopup()\"\n    >language</mat-icon>\n  </div>\n  <div class=\"pop-out-container\" [ngClass]=\"{'slide-down': expanded }\">\n    <div *ngFor=\"let locale of supportedLocales; let i = index\">\n      <div *ngIf=\"i > 0 && locale[localeIdentifier]\">\n        <mat-form-field appearance=\"outline\" floatLabel=\"always\">\n          <mat-label>{{label}} - {{locale[localeLabel]}}</mat-label>\n          <input\n            id=\"{{groupId}}_{{locale[localeIdentifier].toLowerCase()}}\"\n            name=\"{{groupId}}_{{locale[localeIdentifier].toLowerCase()}}\"\n            #defaultLocaleString=\"ngModel\"\n            matInput\n            (blur)=\"onInputChange(i)\"\n            [(ngModel)]=\"returnModel[locale[localeIdentifier]]\"\n            placeholder=\"{{ placeholder }}\"\n            [required]=\"isRequired\"\n            [maxlength]=\"length\"\n            [attr.data-url-persist]=\"deeplinkPersist\"\n            (keyup.escape)=\"closePopup()\"\n          >\n          <mat-error\n            *ngIf=\"defaultLocaleString.invalid && (defaultLocaleString.dirty || defaultLocaleString.touched)\"\n            class=\"alert alert-danger\"\n          >\n            <mat-error *ngIf=\"defaultLocaleString.errors && defaultLocaleString.errors['required']\">\n              <span>{{\"multi-locale-input.MultiLocaleInput.app.required\" | translate}}</span>\n            </mat-error>\n          </mat-error>\n        </mat-form-field>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"multi-locale-overlay\" [ngClass]=\"{'show': expanded }\" (click)=\"closePopup()\">\n</div>\n\n", styles: ["input{border:none;padding-right:25px}input.failure{outline:#FF0000}.hide{display:none}.contain{position:relative}.language-icon{position:absolute;top:17px;right:5px;color:#461e7d;opacity:1}.language-icon:hover,.language-icon.active{cursor:pointer;border-radius:32px;opacity:.5}.language-icon.invalid{color:red}.pop-out-container{display:none}.slide-down{display:block}.mat-form-field{width:100%}.mat-form-field.mat-form-field-appearance-outline .mat-form-field-outline{color:red}.mat-form-field.mat-form-field-appearance-outline .mat-form-field-outline-thick{color:red;opacity:1}.invalid .mat-form-field-appearance-outline .mat-form-field-outline{color:red}.mat-error .group-error{font-size:75%;padding-left:10px;font-weight:400;line-height:1.125;font-family:Avenir;letter-spacing:1.5px;display:block}.group-error-wrapper{margin-top:-15px}@keyframes slide-down{to{top:60px;opacity:1;display:block}}@media only screen and (min-width: 768px){.pop-out-container{background:#ffffff;border:solid 1px #999;border-radius:3px;box-shadow:1px 2px 6px #0006;padding:20px 20px 0;display:none;z-index:10000;position:absolute;width:100%}.pop-out-container mat-form-field{padding-bottom:15px}.multi-locale-overlay{display:none}.multi-locale-overlay.show{position:absolute;z-index:9999;width:100%;height:100%;display:block;top:0;left:0}.slide-down{top:0;opacity:0;-webkit-animation:slide-down .25s forwards;-webkit-animation-delay:0s;animation:slide-down .25s forwards;animation-delay:0s;display:block}}\n"] }]
    }], null, { onChange: [{
            type: Output
        }], locales: [{
            type: Input,
            args: ['locales']
        }], inputLabel: [{
            type: Input,
            args: ['inputLabel']
        }], localeKey: [{
            type: Input,
            args: ['localeKey']
        }], displayLabelKey: [{
            type: Input,
            args: ['displayLabelKey']
        }], defaultLocale: [{
            type: Input,
            args: ['defaultLocale']
        }], placeholderText: [{
            type: Input,
            args: ['placeholderText']
        }], required: [{
            type: Input,
            args: ['required']
        }], maxLength: [{
            type: Input,
            args: ['maxLength']
        }], id: [{
            type: Input,
            args: ['id']
        }], deeplinkPersist: [{
            type: Input,
            args: ['deeplink-persist']
        }] }); })();

function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}
class MultiLocaleModule {
}
/** @nocollapse */ MultiLocaleModule.ɵfac = function MultiLocaleModule_Factory(t) { return new (t || MultiLocaleModule)(); };
/** @nocollapse */ MultiLocaleModule.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: MultiLocaleModule });
/** @nocollapse */ MultiLocaleModule.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ providers: [TranslateService, HttpClient], imports: [CommonModule, MatFormFieldModule, MatInputModule, FormsModule, MatIconModule, MatRippleModule, HttpClientModule, TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        })] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiLocaleModule, [{
        type: NgModule,
        args: [{
                declarations: [MultiLocaleComponent, LocaleGroupValidator],
                exports: [MultiLocaleComponent],
                imports: [CommonModule, MatFormFieldModule, MatInputModule, FormsModule, MatIconModule, MatRippleModule, HttpClientModule, TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useFactory: (createTranslateLoader),
                            deps: [HttpClient]
                        }
                    })],
                providers: [TranslateService, HttpClient]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MultiLocaleModule, { declarations: [MultiLocaleComponent, LocaleGroupValidator], imports: [CommonModule, MatFormFieldModule, MatInputModule, FormsModule, MatIconModule, MatRippleModule, HttpClientModule, i8.TranslateModule], exports: [MultiLocaleComponent] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MultiLocaleComponent, MultiLocaleModule, createTranslateLoader };
